import { autorun } from "mobx";  
import { CountryWithStateModel, StateModel } from "./CountryModels";
import { getNewErrors, InputErrorModel } from "@mindmemobile/mm-shared-global"; 
import { IAPIAddressModel } from "../interfaces/IAPIAddressModel";
 

export class AddressModel {
    country: string;
    city: string;
    zipCode: string;
    countryCode: string;
    state: StateModel;
    address1: string;
    address2: string;
    address3: string;
    countryDetails: CountryWithStateModel;
    errors: InputErrorModel<AddressModel>[];
    constructor(data?: Partial<AddressModel>) {
        this.country = data?.country || '';
        this.city = data?.city || '';
        this.zipCode = data?.zipCode || '';
        this.countryCode = data?.countryCode || '';
        this.state = data?.state || new StateModel();
        this.address1 = data?.address1 || '';
        this.address2 = data?.address2 || '';
        this.address3 = data?.address3 || '';
        this.countryDetails = data?.countryDetails || new CountryWithStateModel();
        this.errors =
            (data &&
                data.errors?.map((e) => {
                    return new InputErrorModel<AddressModel>(e);
                })) ||
            [];
        autorun(() => {
            this.validate(true);
        });
    }

    hasError(field: keyof AddressModel): boolean {
        return this.errors.some((error) => error.field === field);
    }

    validate(isAutoRun: boolean = false) {
        const newErrors: InputErrorModel<AddressModel>[] = [];
        if (!this.address1) {
            newErrors.push(
                new InputErrorModel<AddressModel>({
                    field: 'address1',
                    message: 'Street Address 1 is required',
                }),
            );
        }
        if (!this.city) {
            newErrors.push(
                new InputErrorModel<AddressModel>({
                    field: 'city',
                    message: 'City is required',
                }),
            );
        }
        if (!this.zipCode) {
            newErrors.push(
                new InputErrorModel<AddressModel>({
                    field: 'zipCode',
                    message: 'Zip Code is required',
                }),
            );
        }
        if (!this.state.name) {
            newErrors.push(
                new InputErrorModel<AddressModel>({
                    field: 'state',
                    message: 'State is required',
                }),
            );
        }
        if (!this.countryDetails?.name) {
            newErrors.push(
                new InputErrorModel<AddressModel>({
                    field: 'country',
                    message: 'Country is required',
                }),
            );
        }
        this.errors = isAutoRun ? getNewErrors(newErrors, this.errors) : newErrors;
        return this.errors.length === 0;
    }

    static deserializeAPIModel(data: IAPIAddressModel): AddressModel {
        const mappedData: Partial<AddressModel> = {
            country: data.country,
            city: data.city,
            zipCode: data.zipCode,
            countryCode: data.countryCode,
            state: new StateModel({ name: data.state, id: data.stateId ? data.stateId : '' }),
            address1: data.address1,
            address2: data.address2,
            address3: data.address3,
            countryDetails: new CountryWithStateModel({
                name: data.country,
                code: parseInt(data.countryCode),
                id: data.countryId ? data.countryId : '',
            }),
        };
        return new AddressModel(mappedData);
    }

    static desrializeAddress(address?: AddressModel): string {
        if (address?.countryCode !== '') {
            return `${address?.address1 || ''} ${address?.address2 || ''} ${address?.address3 || ''} ${address?.city || ''} ${address?.state || ''} ${address?.zipCode || ''} ${address?.country || ''}`;
        }
        return '';
    }

    createAPIModel(): IAPIAddressModel {
        return {
            country: this.countryDetails.name,
            city: this.city,
            zipCode: this.zipCode,
            countryCode: this.countryDetails.code.toString(),
            state: this.state.name,
            address1: this.address1,
            address2: this.address2,
            address3: this.address3,
            countryId: this.countryDetails.id,
            stateId: this.state.id,
        };
    }
}
